export enum ItemType {
  CHAIR,
  WHITEBOARD,
  VENDINGMACHINE,
  COMPUTER,
}
